import {
  Smartphone, Gamepad2, ShoppingCart, Watch, Shirt, Sparkles,
  Sofa, Baby, Plane, Car, Hammer, Gift, Tag, Laptop,
  Dumbbell, UtensilsCrossed, BookOpen, Leaf,
} from "lucide-react";

export const CATEGORIES = [
  { name: "Elektronik",      icon: Smartphone,      color: "#0071E3" },
  { name: "Computer",        icon: Laptop,           color: "#5856D6" },
  { name: "Gaming",          icon: Gamepad2,         color: "#A259FF" },
  { name: "Haushalt",        icon: UtensilsCrossed,  color: "#FF8A3D" },
  { name: "Home & Living",   icon: Sofa,             color: "#8E8E93" },
  { name: "Wearables",       icon: Watch,            color: "#FF62A5" },
  { name: "Mode & Bekleidung", icon: Shirt,          color: "#34C759" },
  { name: "Sport & Fashion", icon: Shirt,            color: "#34C759" },
  { name: "Sport & Outdoor", icon: Dumbbell,         color: "#00C7BE" },
  { name: "Beauty & Pflege", icon: Sparkles,         color: "#FF2D92" },
  { name: "Beauty",          icon: Sparkles,         color: "#FF2D92" },
  { name: "Baby & Familie",  icon: Baby,             color: "#FF9500" },
  { name: "Lebensmittel",    icon: ShoppingCart,     color: "#34C759" },
  { name: "Spielzeug",       icon: Gift,             color: "#AF52DE" },
  { name: "Reisen",          icon: Plane,            color: "#00C7BE" },
  { name: "Auto & Motorrad", icon: Car,              color: "#FF3B30" },
  { name: "Baumarkt",        icon: Hammer,           color: "#8E8E93" },
  { name: "Baumarkt & Garten", icon: Leaf,           color: "#8E8E93" },
  { name: "Büro & Schule",   icon: BookOpen,         color: "#64748B" },
  { name: "Sonstiges",       icon: Tag,              color: "#64748B" },
];

export const catMeta = (name) => CATEGORIES.find((c) => c.name === name) || { name, icon: Tag, color: "#64748B" };

export const ASSETS = {
  mascot3d: "/wizard-mascot.png",
  heroBg: "/wizard-mascot.png",
  magicBox: "/wizard-icon.png",
};
